"use client"

import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import { useTranslations } from 'next-intl'
import SvgArrow from '@/src/assets/svgs/collection/arrow-left.svg'
import { useShoppingCart } from '@/src/context/shopping-cart/shopping-cart-context'
import RemoveCoupon from '../remove-coupon/remove-coupon'
import RemoveCashback from '../remove-cashback/remove-cashback'
import { usePathname } from 'next/navigation'
import CouponInput from '../../misc/coupon-input/coupon-input'

export default function ApplyCoupon() {
    const t = useTranslations('shopping-cart')
    const { shoppingCart, removeCoupon, removeCashback, cashbackFullPrice } = useShoppingCart()
    const pathname = usePathname()

    const [showInput, setShowInput] = useState(false)

    const removeCurrentCashback = () => {
        removeCashback()

        if (pathname.startsWith('/fidelidade'))
            window.location.reload()
    }

    useEffect(() => {
        setShowInput(!!shoppingCart?.coupon)
    }, [shoppingCart])

    return (
        <div className={styles.container}>
            <div className={styles.subContainer}>
                {
                    cashbackFullPrice <= 0 &&
                    <>
                        <div onClick={() => setShowInput(!showInput)} className={styles.collapse}>
                            <h5 className={`${styles.title} font-md`}>{t('coupon')}</h5>
                            <SvgArrow className={showInput ? styles.hideRotateArrow : styles.showRotateArrow} />
                        </div>
                        {
                            showInput &&
                            <div className={styles.applyCouponArea}>
                                {
                                    (shoppingCart?.coupon && shoppingCart)
                                        ?
                                        <RemoveCoupon name={shoppingCart.coupon.name} remove={removeCoupon} />
                                        :
                                        <CouponInput />
                                }
                            </div>
                        }
                    </>
                }
                {cashbackFullPrice > 0 && <RemoveCashback remove={removeCurrentCashback} />}
            </div>
        </div>
    )
}
